import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import imgixConfig from 'Config/imgix';

import 'Components/Search/BrowseBanner/BrowseBanner.scss';

export default function BrowseBanner({
  title,
  filter,
  pathname,
  position,
  backgroundImage,
  squareDesign,
}) {
  const words = title.split(' ');
  const firstWord = words[0];

  if (squareDesign) {
    return (
      <Link to={`${pathname}?${filter}`} className="BrowseBanner BrowseBanner--square">
        <div className="BrowseBanner__content">
          <div className="BrowseBanner__content__title">
            <div>{firstWord}</div>
            {words.length > 1 &&
              <div>
                {words.slice(1).map((word, i) => {
                  const key = `${word}${i}`;
                  return <span key={key}>{`${word} `}</span>;
                })}
              </div>
            }
          </div>
          <div className="BrowseBanner__content__icon">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </div>

        <div className={`BrowseBanner__background BrowseBanner__background--${position}`}>
          <img src={`${backgroundImage}?${imgixConfig}`} alt="" />
        </div>
      </Link>
    );
  }

  return (
    <Link to={`${pathname}?${filter}`} className="BrowseBanner">
      <div className="BrowseBanner__content">
        <div className="BrowseBanner__content__title">
          {title}
        </div>
      </div>

      <div className={`BrowseBanner__background BrowseBanner__background--${position}`}>
        <img src={`${backgroundImage}?${imgixConfig}`} alt="" />
      </div>
    </Link>
  );
}

BrowseBanner.propTypes = {
  title: PropTypes.string,
  filter: PropTypes.string,
  pathname: PropTypes.string,
  position: PropTypes.string,
  backgroundImage: PropTypes.string,
  squareDesign: PropTypes.bool,
};

BrowseBanner.defaultProps = {
  title: '',
  filter: '',
  pathname: '',
  position: '',
  backgroundImage: 'https://fanatical.imgix.net/product/original/games-under-middle.jpeg',
  squareDesign: false,
};
